// INSTANCES
import { ApiAxiosInstance } from '../instances/apiAxiosInstance';

// TYPE
import {
  FilterTeamUsers,
  UsersTeamPaginatedResponse,
} from '@/modules/team/types/users.type';

/**
 * @deprecated Usar teamUserService.getTeamUsers de '@/shared/common'
 */
export const multiuserClient = {
  getUsers(params: FilterTeamUsers) {
    return ApiAxiosInstance.get<UsersTeamPaginatedResponse>(
      'company/b2b/teams/users',
      {
        params,
      }
    );
  },
};
